import { DateTime } from "luxon"

export enum SocialPlatform {
    twitter = "twitter",
    instagram = "instagram",
    youtube = "youtube",
    discord = "discord",
    linkedin = "linkedin",
    email = "email"
}

export type Social = {
    social: SocialPlatform,
    link: string
}

export type TeamMember = {
    name: string,
    title: string,
    profilePicture: string | null,
    socials?: Social[],
    bio: string,
    gameOfChoice: string
}

export type Talent = {
    name: string,
    profilePicture: string | null,
    bio: string
}

export interface TimelineEvent {
    id: string
    title: string
    description: string
    date: DateTime
    spacingAfter?: number
}

export type TimelineEventStatus = "past" | "current" | "future"